export default "__VITE_ASSET__1a6401bf__"